<template>
  <div class="any">
    <el-divider content-position="left">财税交接人员配置</el-divider>
    <!-- <div style="height: 0.5rem"></div> -->
    <el-divider content-position="left">零申报</el-divider>
    <el-table
      :data="zeroDeclareData"
      border
      size="medium"
      :header-cell-style="tableHeaderStyle"
    >
      <el-table-column prop="leader_id" label="财税负责人" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="zeroLeaderSelect"
              v-model="zero_leader_id"
              placeholder="请选择财税负责人"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('leader_id', 'zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('zero_leader_id', authUserId)">{{
              scope.row.leader_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="acc_id" label="理票会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="zeroAccSelect"
              v-model="zero_acc_id"
              placeholder="请选择理票会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('acc_id', 'zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('zero_acc_id', authUserId)">{{
              scope.row.acc_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="advisory_id" label="记账报税会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="zeroAdvisorySelect"
              v-model="zero_advisory_id"
              placeholder="请选择记账报税会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('advisory_id', 'zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('zero_advisory_id', authUserId)">{{
              scope.row.advisory_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="invoice_id" label="开票会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="zeroInvoiceSelect"
              v-model="zero_invoice_id"
              placeholder="请选择开票会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('invoice_id', 'zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('zero_invoice_id', authUserId)">{{
              scope.row.invoice_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="ass_id" label="客服会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="zeroAssSelect"
              v-model="zero_ass_id"
              placeholder="请选择客服会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('ass_id', 'zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('zero_ass_id', authUserId)">{{
              scope.row.ass_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div style="height: 2rem"></div>

    <el-divider content-position="left">非零申报</el-divider>
    <el-table
      :data="NotZeroDeclareData"
      border
      size="medium"
      :header-cell-style="tableHeaderStyle"
    >
      <el-table-column prop="leader_id" label="财税负责人" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="notZeroLeaderSelect"
              v-model="not_zero_leader_id"
              placeholder="请选择财税负责人"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('leader_id', 'not_zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('not_zero_leader_id', authUserId)">{{
              scope.row.leader_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="acc_id" label="理票会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="notZeroAccSelect"
              v-model="not_zero_acc_id"
              placeholder="请选择理票会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('acc_id', 'not_zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('not_zero_acc_id', authUserId)">{{
              scope.row.acc_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="advisory_id" label="记账报税会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="notZeroAdvisorySelect"
              v-model="not_zero_advisory_id"
              placeholder="请选择记账报税会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('advisory_id', 'not_zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('not_zero_advisory_id', authUserId)">{{
              scope.row.advisory_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="invoice_id" label="开票会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="notZeroInvoiceSelect"
              v-model="not_zero_invoice_id"
              placeholder="请选择开票会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('invoice_id', 'not_zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('not_zero_invoice_id', authUserId)">{{
              scope.row.invoice_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="ass_id" label="客服会计" width="150">
        <template slot-scope="scope">
          <el-tooltip content="点击修改" placement="top">
            <el-select
              v-if="notZeroAssSelect"
              v-model="not_zero_ass_id"
              placeholder="请选择客服会计"
              style="width: 100%"
              size="mini"
              filterable
              @change="onlineChoose('ass_id', 'not_zero')"
            >
              <el-option
                v-for="item in adminUsers"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span v-else style="cursor: pointer" @click="onlineUpdate('not_zero_ass_id', authUserId)">{{
              scope.row.ass_id
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "FinancerSwitch",
  data() {
    return {
      zeroDeclareData: [],
      NotZeroDeclareData: [],
      adminUsers: [],
      authUserId: "",

      zeroLeaderSelect: false,
      zero_leader_id: null,
      zeroAccSelect: false,
      zero_acc_id: null,
      zeroAdvisorySelect: false,
      zero_advisory_id: null,
      zeroInvoiceSelect: false,
      zero_invoice_id: null,
      zeroAssSelect: false,
      zero_ass_id: null,

      notZeroLeaderSelect: false,
      not_zero_leader_id: null,
      notZeroAccSelect: false,
      not_zero_acc_id: null,
      notZeroAdvisorySelect: false,
      not_zero_advisory_id: null,
      notZeroInvoiceSelect: false,
      not_zero_invoice_id: null,
      notZeroAssSelect: false,
      not_zero_ass_id: null,
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
    tableHeaderStyle() {
      return {
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      };
    },
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    loadTable() {
      this.$axios
        .get("api/admin/box_setting/get_financer")
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.zeroDeclareData = data.data.returnZeroDeclarer;
            this.NotZeroDeclareData = data.data.returnNotZeroDeclarer;
            this.adminUsers = data.data.adminer;
            this.authUserId = data.data.userId;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    onlineUpdate (field, authUserId) {
      if (field === "zero_leader_id" && authUserId === 251) {
        this.zeroLeaderSelect = true;
      } else if (field === "zero_acc_id" && authUserId === 251) {
        this.zeroAccSelect = true;
      } else if (field === "zero_advisory_id" && authUserId === 251) {
        this.zeroAdvisorySelect = true;
      } else if (field === "zero_invoice_id" && authUserId === 251) {
        this.zeroInvoiceSelect = true;
      } else if (field === "zero_ass_id" && authUserId === 251) {
        this.zeroAssSelect = true;
      } else if (field === "not_zero_leader_id" && authUserId === 251) {
        this.notZeroLeaderSelect = true;
      } else if (field === "not_zero_acc_id" && authUserId === 251) {
        this.notZeroAccSelect = true;
      } else if (field === "not_zero_advisory_id" && authUserId === 251) {
        this.notZeroAdvisorySelect = true;
      } else if (field === "not_zero_invoice_id" && authUserId === 251) {
        this.notZeroInvoiceSelect = true;
      } else if (field === "not_zero_ass_id" && authUserId === 251) {
        this.notZeroAssSelect = true;
      }
    },
    onlineChoose (field, type) {
      let serverId = null
      if (field === 'leader_id' && type === 'zero') {
        serverId = this.zero_leader_id
      } else if (field === 'acc_id' && type === 'zero') {
        serverId = this.zero_acc_id
      } else if (field === 'advisory_id' && type === 'zero') {
        serverId = this.zero_advisory_id
      } else if (field === 'invoice_id' && type === 'zero') {
        serverId = this.zero_invoice_id
      } else if (field === 'ass_id' && type === 'zero') {
        serverId = this.zero_ass_id
      } else if (field === 'leader_id' && type === 'not_zero') {
        serverId = this.not_zero_leader_id
      } else if (field === 'acc_id' && type === 'not_zero') {
        serverId = this.not_zero_acc_id
      } else if (field === 'advisory_id' && type === 'not_zero') {
        serverId = this.not_zero_advisory_id
      } else if (field === 'invoice_id' && type === 'not_zero') {
        serverId = this.not_zero_invoice_id
      } else if (field === 'ass_id' && type === 'not_zero') {
        serverId = this.not_zero_ass_id
      }

      this.$axios
        .post('api/admin/box_setting/online_update', {
          serverId: serverId,
          field: field,
          type: type
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.zeroLeaderSelect = false
            this.zeroAccSelect = false
            this.zeroAdvisorySelect = false
            this.zeroInvoiceSelect = false
            this.zeroAssSelect = false
            this.notZeroLeaderSelect = false
            this.notZeroAccSelect = false
            this.notZeroAdvisorySelect = false
            this.notZeroInvoiceSelect = false
            this.notZeroAssSelect = false
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
  },
};
</script>

<style scoped>
.any {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/FinancerSwitch.vue